import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KakobuySpreadsheetGuide from "../pages/article/KakobuySpreadsheetGuide";
import KakobuyVsCompetitors from "../pages/article/KakobuyVsCompetitors";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/kakobuy-vs-competitors",
    element: <KakobuyVsCompetitors />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;